module.exports = __webpack_public_path__ + "img/Keluar.aed5588f.svg";